import React from 'react'
import Footer from '../../common/Footer/Footer'
import Header from '../../common/Header/Header'
import Slide from '../Home/Carousel/Slide'
import About from '../About/About'
import MailUs from '../MailUs/MailUs'
import Caro1 from './Caro1/Caro1'
import Nav from './Nav/Nav'
import Vision from '../vision/Vision'
import Services from '../services/Services'
import Ourclient from '../OurClient/Ourclient'

const Home = () => {
  return (
    <>
    <Nav/>
    <Caro1/>
    <About/>
    {/* <Ourclient/> */}
    <Vision/>
    <Services/>
   
    <MailUs/>
    <Footer/>
    </>
  )
}

export default Home